import { render, staticRenderFns } from "./CardAlert.vue?vue&type=template&id=51f393cb&scoped=true"
import script from "./CardAlert.vue?vue&type=script&lang=js"
export * from "./CardAlert.vue?vue&type=script&lang=js"
import style0 from "./CardAlert.vue?vue&type=style&index=0&id=51f393cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f393cb",
  null
  
)

export default component.exports